/* eslint import/no-webpack-loader-syntax: off */

import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

import { sendNotificationReadReceipt } from '../../actions/user';

import Notifications from '-!svg-react-loader!./notifications.svg'; // eslint-disable-line
import Notification from './components/Notification';

export default class NotificationsMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
    };
    this.readHandler = this.notificationRead.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  notificationRead(id, type) {
    this.toggleMenu();
    this.props.dispatch(sendNotificationReadReceipt(id, type, this.props.user.access_token));
  }

  toggleMenu(e, preventDefault) {
    if (preventDefault) e.preventDefault();
    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  }

  render() {
    const unreadNotifications = this.props.user.unread_notifications;

    return (
      <div
        className={
          css(styles.container, this.state.menuOpen ? styles.container_top : null) +
          ' SVGContainer NotificationsSVG'
        }
        onMouseEnter={!Theme.isMobile && !this.state.menuOpen ? this.toggleMenu : null}
        onMouseLeave={!Theme.isMobile && this.state.menuOpen ? this.toggleMenu : null}
      >
        {Theme.isMobile && this.state.menuOpen ? (
          <div className={css(styles.close)} onClick={this.toggleMenu} role="button" tabIndex={0} />
        ) : null}
        <Link
          to="/inbox"
          className={css(styles.link)}
          onClick={Theme.isMobile ? e => this.toggleMenu(e, true) : null}
        >
          <Notifications className={css(styles.icon)} />
          {unreadNotifications && unreadNotifications.length ? (
            <div className={css(styles.unread_notifications)} />
          ) : (
            false
          )}
        </Link>

        <ul className={css(styles.menu, this.state.menuOpen ? styles.menu_open : null)}>
          {unreadNotifications && unreadNotifications.length > 0 ? (
            unreadNotifications.map(notification => (
              <Notification
                id={notification.id}
                type={notification.type}
                handler={this.readHandler}
                image={notification.image_url}
                profileLink={`/${notification.type}/${notification.profile_id}`}
              >
                {notification.message}
              </Notification>
            ))
          ) : (
            <div className={css(styles.center)}>
              You don{"'"}t have any notifications right now.
            </div>
          )}
        </ul>
      </div>
    );
  }
}

NotificationsMenu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.func.isRequired,
};

const styles = StyleSheet.create({
  close: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    content: '""',
  },
  container_top: {
    zIndex: 9,
  },
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: Theme.navigation.height,
    marginLeft: 10,
    marginRight: 10,

    [Theme.mobile_query]: {
      position: 'static',
      marginLeft: 10,
      marginRight: 5,
    },

    ':hover > svg': {
      fill: '#39b4d6',

      [Theme.mobile_query]: {
        fill: '#000',
      },
    },
  },

  icon: {
    transition: 'all 300ms',
  },

  menu: {
    position: 'absolute',
    top: '100%',
    right: -10,
    width: 385,
    color: Theme.white,
    backgroundColor: '#021a36',
    transformOrigin: 'top center',
    transition: 'all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275)',
    pointerEvents: 'none',
    opacity: 0,
    transform: 'rotateX(-100deg)',

    [Theme.mobile_query]: {
      right: 0,
      width: '100vw',
    },
  },
  menu_open: {
    transform: 'rotate(0deg)',
    opacity: 1,
    pointerEvents: 'initial',
  },
  center: {
    padding: 30,
    display: 'block',
    textAlign: 'center',
  },
  link: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  unread_notifications: {
    position: 'absolute',
    width: 14,
    height: 14,
    borderRadius: 7,
    backgroundColor: Theme.secondary,
    right: -2,
    top: 0,
  },
});



// WEBPACK FOOTER //
// ./src/components/NotificationsMenu/index.js